import React from 'react';
import InterviewApp from './components/InterviewApp';
import AppErrorBoundary from './components/AppErrorBoundary';
// import InterviewAppLegacy from './components/InterviewApp.legacy';
import { getUrlParameter } from './utils/helpers';
import './App.css';

function App() {
  // MIGRATION COMPLETE: Zustand is now the default!
  // Use original useReducer version only if explicitly requested
  const useOriginal = getUrlParameter('original') === 'true' || getUrlParameter('reducer') === 'true';

  // Visual indicator for which version is running
  const version = useOriginal ? 'useReducer (Legacy)' : 'Zustand';

  // Dev-only route switch using query param `voice-test` (disabled in production builds
  // unless the test page is committed). To avoid build failures on environments
  // where the dev-only files are not present, we always render InterviewApp.
  // const voiceTest = getUrlParameter('voice-test') === 'true';

  return (
    <div className="App">
      {/* Development indicator - shows which state management is active */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{
          position: 'fixed',
          top: 0,
          right: 0,
          background: useOriginal ? '#6c757d' : '#28a745',
          color: 'white',
          padding: '4px 8px',
          fontSize: '12px',
          zIndex: 1000,
          borderBottomLeftRadius: '4px'
        }}>
          State: {version}
        </div>
      )}

      <AppErrorBoundary>
        {useOriginal ? (
          // <InterviewAppLegacy />
          <div>Legacy version not available</div>
        ) : (
          <InterviewApp />
        )}
      </AppErrorBoundary>
    </div>
  );
}

export default App;
